

import {ref} from 'vue'
import {useToast} from "primevue/usetoast";
import AuthRepository from "@/services/AuthRepository";
import {useStore} from "vuex";
import router from "@/router";
import {Team} from "@/models/team.models";
import TeamRepository from "@/services/TeamRepository";
import {FilterMatchMode} from "primevue/api";
import {User} from "@/models/user.models";

export default {
  setup() {
    const toast = useToast();
    const isLoading = ref(false);
    const list = ref([] as User[]);
    const teams = ref({} as Team[]);

    TeamRepository.getTeams()
            .then((response) => {
              teams.value = response.data;
              AuthRepository.userList()
                      .then(response => {
                        list.value = response.data;
                        list.value.forEach(x => {
                          teams.value.forEach(y => {
                            if(y.code == x.team) x.team = y.name;
                          });
                          userPermission.value.forEach(y => {
                            if(y.value == x.permission) x.permission = y.label;
                          });
                        });
                      })
                      .catch(() => {
                        toast.add({
                          severity: 'error',
                          summary: 'Thất bại',
                          detail: 'Không thể tải danh sách lịch đặt chổ.',
                          life: 1000
                        });
                      })
                      .finally(() => {
                        isLoading.value = false;
                      });

            })
            .catch();

    const userPermission = ref([
      { label: 'Nhân viên', value: 'user' },
      { label: 'Quản lý', value: 'admin' },
    ]);
    const store = useStore();

    if(!(store.state.permission == 'admin')){
      router.push({
        name: 'home'
      });
    }

    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    // const nonAccentVietnamese = (str: string) => {
    //   str = str.toLowerCase();
    //   str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    //   str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    //   str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    //   str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    //   str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    //   str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    //   str = str.replace(/đ/g, "d");
    //   // Some system encode vietnamese combining accent as individual utf-8 characters
    //   str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // Huyền sắc hỏi ngã nặng
    //   str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // Â, Ê, Ă, Ơ, Ư
    //   return str;
    // }

    return {
      list,
      filters,
      clearFilter,
      initFilters,
      // nonAccentVietnamese
    }
  }

}
